// extracted by mini-css-extract-plugin
export default {"bymaPairText":"BymaPair_bymaPairText__i0L-n","bymaPairValue":"BymaPair_bymaPairValue__l8yii"};